export const favorites = {
  AddProducts: "Add products",
  AddMoreProducts: "Add more products",
  AddProductsToCategory: "Add products to category",
  AllFavorites: "All favorites",
  Categories: "Categories",
  CategoryNameNotBlank: "Category name cannot be blank",
  CreateNewCategory: "Create new category",
  Favorites: "Favorites",
  FavoriteActions: "Favorites actions",
  FavoritesBlurb:
    "Find products faster by organizing your favorites into categories. {{patientTermCapitalizedPlural}} may be able to purchase products from these categories, depending on your dispensary's settings.",
  PermissionsCanBeChanged:
    "{{patientTermCapitalized}} permissions can be changed by the account owner in Dispensary settings.",
  ProductCount_plural: "{{count}} products",
  ProductCount: "{{count}} product",
  SearchForProducts1: "Search for products in our catalog and select",
  SearchForProducts2: "to add them to a favorites category.",
  SearchCatalog: "Search catalog",
  SearchForProductsCategory: "Search our catalog to add products to this category.",
  StartAddingProducts: "Start adding your favorite products",
  SelectCategoryAndAdd: "Select a favorite category on the left to start adding products to it.",
  ViewCategory: "View category",
  ViewMore: "View more",
  ViewAll: "View all",
  YourFavorites: "Your favorites",
  AddToCategory: "Add your favorite products to {{- categoryName}}",
  AddToACategory: "Add to a category",
  OtherCategories: "Other categories",
  CategoriesEmptyState: "You have no other categories",
  CreateCategory: "Create category",
  Done: "Done",
  SelectForAdd: "Select any categories you want to add this product to.",
  Cancel: "Cancel",
  Name: "Name",
  CategoryName: "Category name",
  DefaultVisibility: "Categories are visible to you and your staff by default.",
  MakeVisible: "Make visible to {{ patientTerm }}",
  MakeVisibleDescription:
    "If enabled, all {{ patientTerm }} in your dispensary will see this category, including minor dependents managed by parents.",
  EditFavoriteCategory: "Edit category",
  SearchFavoriteCategory: "Search {{- categoryName}}",
  ProvidersAndStaff: "Providers and staff",
  PatientsProvidersAndStaff: "{{ patientTerm }}, providers, and staff",
  DeleteFavoriteCategory: "Delete category",
  DeleteConfirmationMessage: 'Are you sure you want to delete the category "{{- categoryName}}"?',
  PatientsVisibilityMessage: "Your {{ patientTerm }} will no longer see this.",
  ProductSaved: "Product saved",
  CategoryDeleted: "Category deleted",
  Remove: "Remove",
  LoadMore: "Load more",
  RemovedFromFavorites: "Removed from favorites",
  AddToFavorites: "Add to favorites",
  RemoveFromFavorites: "Remove from favorites",
  RemoveFromCategory: "Remove product from category",
  RemoveConfirmMessage:
    "This product will be removed from 'All Favorites' and all other categories.",
  NoResultsFound: "No results found",
  ClearSearch: "Clear search",
  NoFavoritedProducts: "You don't have any products here",
  NoFavoritedProductsSubtitle: "Added products will be added here",
  SavedToCategory: "Saved to category",
  RemovedFromCategory: "Removed from category",
  Create: "Create",
} as const;
